var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.5V18.25C22 17.9185 22.1317 17.6005 22.3661 17.3661C22.6005 17.1317 22.9185 17 23.25 17H40.75C41.0815 17 41.3995 17.1317 41.6339 17.3661C41.8683 17.6005 42 17.9185 42 18.25V29.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22H29.5",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 29.5C45.75 33.1467 44.3013 36.6441 41.7227 39.2227C39.1441 41.8013 35.6467 43.25 32 43.25C28.3533 43.25 24.8559 41.8013 22.2773 39.2227C19.6987 36.6441 18.25 33.1467 18.25 29.5H45.75Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4407 42.08L25.7625 46.8237C25.7372 47.001 25.7503 47.1816 25.8009 47.3534C25.8515 47.5252 25.9384 47.6841 26.0558 47.8194C26.1731 47.9546 26.3181 48.0631 26.4811 48.1375C26.644 48.2118 26.821 48.2503 27 48.2503H37C37.1791 48.2503 37.3561 48.2118 37.519 48.1375C37.6819 48.0631 37.827 47.9546 37.9443 47.8194C38.0616 47.6841 38.1486 47.5252 38.1991 47.3534C38.2497 47.1816 38.2628 47.001 38.2375 46.8237L37.5594 42.08",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.10640328db70928ce2b59b7b84589f0e.svg";
export { ForwardRef as ReactComponent };